import React from 'react'
import { FormInputSelectAndNavigateBranch } from '../../../../../../../ui/organisms'
import { toJS } from 'mobx'
import { useStore } from '../../../../../../../store'

let list = [
  {
    value: 'I perform alternative trades on this project',
    next: 'projectInfo.projectTrade2',
  },
  {
    value: 'I perform additional trades on this project',
    next: 'projectInfo.projectTrade2',
  },
]

export default {
  title: 'What trade do you perform for this project?',
  list,
  component: (props) => {
    const { userStore } = useStore()
    const loanApplication = userStore.document

    const trades = loanApplication?.data?.get('businessInfo')?.get('trade')
    console.log('trades',trades)

    if(trades?.length){
      for(let trade of trades){
        list.unshift({
          value: trade,
          next: 'projectInfo.projectPayingParty'
        })
      }
    }

    
    return(
      <FormInputSelectAndNavigateBranch list={list} {...props}/>
    )
  }
}
